import {Controller} from '@stimulus/core'
import HSGoTo from '../../../../../vendor/front/vendor/hs-go-to/src/js/hs-go-to'

// data-controller='hs--go-to'
// data-hs-go-to-options='{}' https://htmlstream.com/preview/front-v3.2.2/documentation/go-to.html#methods

export default class extends Controller {
  static values = {
    autoclick: Boolean
  }

  connect() {
    new HSGoTo($(this.element)).init()

    if (this.autoclickValue) {
      this.element.click()
    }
  }
}
